import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NoImageIconComponent } from '@itero/ui-toolkit-angular/icons';

@Component({
	selector: 'rx-intuitive-attachments-replacement',
	templateUrl: './rx-intuitive-attachments-replacement.component.html',
	styleUrls: ['./rx-intuitive-attachments-replacement.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [CommonModule, TranslateModule, NoImageIconComponent],
	host: {
		class: 'intuitive-attachments-replacement',
		id: 'show-attachments-replacement-section'
	}
})
export class RxIntuitiveAttachmentsReplacementComponent {}
